/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://3dhh2xlarzhkxcffnp63mfstae.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-bx434orzinc7hcmlb2jkq23beu",
    "aws_cognito_identity_pool_id": "ap-south-1:11f15fe2-16d7-47a8-bfa5-4f8827e223ec",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_6yG7ouV97",
    "aws_user_pools_web_client_id": "3pfrjv14s4el3s7uqo8ur65k93",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "bryo-client-guest-ids205318-dev",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
